export default [
  {
    path: '/field-management/projects',
    name: 'field-project',
    component: () => import('@/views/field-management/FieldProject.vue'),
    meta: {
      layout: 'content',
      app: 'field-management',
      appId: 14,
    },
  },
  {
    path: '/field-management/project/:project_id',
    name: 'field-management-layout',
    component: () => import('@/views/field-management/FieldLayout.vue'),
    meta: {
      layout: 'content',
      app: 'field-management',
      appId: 9,
    },
    children: [
      {
        path: 'view',
        name: 'field-plans',
        component: () => import('@/views/field-management/FieldPlans.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'photos',
        name: 'field-photos',
        component: () => import('@/views/field-management/FieldPhotos.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'peoples',
        name: 'field-people',
        component: () => import('@/views/field-management/people/FieldPeople.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'add-people',
        name: 'add-people',
        component: () => import('@/views/field-management/people/MapPeople.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'files',
        name: 'field-files',
        component: () => import('@/views/field-management/FieldFiles.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'files/folder/:id?',
        name: 'field-files-folder',
        component: () => import('@/views/field-management/FieldFiles.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'files/folder/:sharedParentId/:id',
        name: 'field-shared-view',
        component: () => import('@/views/field-management/FieldFiles.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: '/files/shared/:id?',
        name: 'field-shared',
        component: () => import('@/views/field-management/SharedFile.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: '/files/favorites/:id?',
        name: 'field-favorite',
        component: () => import('@/views/field-management/Favorite.vue'),
        meta: {
          layout: 'content',
          app: 'work-drive',
          appId: 2,
        },
      },
      {
        path: 'tasks',
        name: 'field-tasks',
        component: () => import('@/views/field-management/FieldTasks.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'pdf/:pdfId/:pageId',
        name: 'field-visualizer',
        component: () => import('@/views/field-management/FieldVisualizer.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'pdf/:pdfId/:pageId/:taskId',
        name: 'field-visualizer-task',
        component: () => import('@/views/field-management/FieldVisualizer.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'form-builder/published-list',
        name: 'field-form-folders',
        component: () => import('@/views/field-management/forms/PublishedTemplateList.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
      {
        path: 'form-builder/:uuid/list',
        name: 'field-template-forms',
        component: () => import('@/views/field-management/forms/FormsList.vue'),
        meta: {
          layout: 'content',
          app: 'field-management',
          appId: 14,
        },
      },
    ],
  },
  {
    path: '/field-management/form-builder/template/:uuid?',
    name: 'field-form-template-list',
    component: () => import('@/views/form-builder/Template/TemplateList.vue'),
    meta: {
      layout: 'content',
      app: 'field-management',
      appId: 14,
    },
  },
  {
    path: '/field-management/my-tasks',
    name: 'my-field-tasks',
    component: () => import('@/views/field-management/FieldMyTasks.vue'),
    meta: {
      layout: 'content',
      app: 'field-management',
      appId: 14,
    },
  },
  {
    path: '/field-management/archives',
    name: 'field-archives',
    component: () => import('@/views/field-management/FieldArchives.vue'),
    meta: {
      layout: 'content',
      app: 'field-management',
      appId: 14,
    },
  },

]
